import { render } from "./authBox.vue?vue&type=template&id=54f46f69"
import script from "./authBox.vue?vue&type=script&lang=js"
export * from "./authBox.vue?vue&type=script&lang=js"

import exportComponent from "/home/soller/sync/Work/Enkiro/casdoor-rust-example/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__